"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GridDemo = /** @class */ (function (_super) {
    __extends(GridDemo, _super);
    function GridDemo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridDemo.prototype.render = function () {
        return (React.createElement("div", null, "Grid Demo Component"));
    };
    return GridDemo;
}(React.Component));
exports.default = GridDemo;
//# sourceMappingURL=GridDemo.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Grid/GridDemo/GridDemo.js
// module id = 1361
// module chunks = 8